import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/features/auth/LoginPage';
import { AccountPage } from '@/pages/AccountPage';
import { AccountsPage } from '@/pages/AccountsPage';
import { AdminsPage } from '@/pages/AdminsPage';
import { AuditPage } from '@/pages/AuditPage';
import { LlmPage } from '@/pages/LlmPage';
import { OverviewPage } from '@/pages/OverviewPage';
import { PaymentsPage } from '@/pages/PaymentsPage';
import { SystemPage } from '@/pages/SystemPage';

function ShellLayout() {
  return (
    <ProtectedRoute>
      <AppShell>
        <Outlet />
      </AppShell>
    </ProtectedRoute>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ShellLayout />,
    children: [
      { path: '/', element: <Navigate to="/overview" replace /> },
      { path: '/overview', element: <OverviewPage /> },
      { path: '/accounts', element: <AccountsPage /> },
      { path: '/accounts/:id', element: <AccountPage /> },
      { path: '/payments', element: <PaymentsPage /> },
      { path: '/audit', element: <AuditPage /> },
      { path: '/admins', element: <AdminsPage /> },
      { path: '/llm', element: <LlmPage /> },
      { path: '/system', element: <SystemPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
